import type { Permission } from '../entities/Access';
import { useActiveUserQuery } from './useActiveUserQuery.hook';

export function usePermission() {
  const {
    data: { user },
  } = useActiveUserQuery();

  const hasPermission = (...permissions: Permission[]) =>
    permissions.some(permission =>
      user.activeWorkspace?.permissions?.includes(permission),
    );

  return { hasPermission };
}
